export default __webpack_public_path__ + "assets/sms-component.88e0b12d.svg";